export class SepaMandate {
  public id: number;
  public file_name: string;
  public created_at: Date;

  constructor(values: Object = {}) {
    Object.assign(this as any, values);
  }
}
